const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign"];
const STORAGE_KEY = "assu_utm";

// Capture les paramètres UTM de l'URL et les conserve (première visite prioritaire)
export function captureUtm() {
  try {
    const params = new URLSearchParams(window.location.search);
    const found = {};
    UTM_KEYS.forEach((key) => {
      const value = params.get(key);
      if (value) found[key] = value.slice(0, 120);
    });
    if (Object.keys(found).length) {
      const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...stored, ...found }));
    }
  } catch {
    // stockage indisponible (navigation privée stricte) : on ignore
  }
}

export function getUtm() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
  } catch {
    return {};
  }
}
